export default __webpack_public_path__ + "static/media/the_mudslide.a346680e.jpg";